import { render } from "./ChatBot.vue.ts?vue&type=template&id=80550131&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBot.vue?vue&type=template&id=80550131&ts=true"
import script from "./ChatBot.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBot.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatBot.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBot.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/person-registration/components/chat-bot/ChatBot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80550131"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80550131', __exports__)) {
    api.reload('80550131', __exports__)
  }
  
  module.hot.accept("./ChatBot.vue.ts?vue&type=template&id=80550131&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ChatBot.vue?vue&type=template&id=80550131&ts=true", () => {
    api.rerender('80550131', render)
  })

}


export default __exports__